"use client";

import { useCallback } from "react";
import { useSearchParams } from "react-router-dom";
import type { TaskConsoleTab } from "@/components/review/taskTabTypes";

const VALID_TABS = new Set<TaskConsoleTab>(["needs_you", "contact", "audit"]);

function parseConsoleTab(value: string | null, fallback: TaskConsoleTab): TaskConsoleTab {
  if (value && VALID_TABS.has(value as TaskConsoleTab)) {
    return value as TaskConsoleTab;
  }
  return fallback;
}

export function useHomeTaskConsoleTabs(defaultTab: TaskConsoleTab = "needs_you") {
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTab = parseConsoleTab(searchParams.get("console"), defaultTab);
  const selectedMissionId = searchParams.get("run");

  const setActiveTab = useCallback(
    (tab: TaskConsoleTab) => {
      const next = new URLSearchParams(searchParams);
      next.set("console", tab);
      setSearchParams(next, { replace: true });
    },
    [searchParams, setSearchParams],
  );

  const setSelectedMissionId = useCallback(
    (missionId: string | null) => {
      const next = new URLSearchParams(searchParams);
      if (missionId) {
        next.set("run", missionId);
      } else {
        next.delete("run");
      }
      setSearchParams(next, { replace: true });
    },
    [searchParams, setSearchParams],
  );

  return {
    activeTab,
    selectedMissionId,
    setActiveTab,
    setSelectedMissionId,
  };
}
